import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { DRIVER_PAYMENT_SCHEDULES } from './queries'
import { fmtFullDateTime, toGlobalId } from './helpers'

const PAGE_SIZE = 5

function pillClass(status) {
    return `cd-pill schedule-${(status || '').toLowerCase().replace(/\s+/g, '-')}`
}

export default function PaymentSchedulesList({ driverId }) {
    const [cursor, setCursor] = useState(null)
    const [stack, setStack] = useState([])
    const driverGlobalId = toGlobalId('DriverNode', driverId)

    const { data, loading, error } = useQuery(DRIVER_PAYMENT_SCHEDULES, {
        variables: { driverId: driverGlobalId, first: PAGE_SIZE, after: cursor },
        fetchPolicy: 'cache-and-network',
        skip: !driverGlobalId,
    })

    const edges = data?.allPaymentSchedules?.edges ?? []
    const pageInfo = data?.allPaymentSchedules?.pageInfo ?? {}

    const next = () => {
        if (pageInfo.endCursor) {
            setStack((s) => [...s, cursor])
            setCursor(pageInfo.endCursor)
        }
    }
    const prev = () => {
        setStack((s) => {
            const copy = [...s]
            const prevCursor = copy.pop() ?? null
            setCursor(prevCursor)
            return copy
        })
    }

    return (
        <div className="cd-section">
            <div className="cd-section-head">
                <h4>Payment schedules</h4>
            </div>
            {loading && !data && (
                <div className="cd-activity-empty">Loading…</div>
            )}
            {error && edges.length === 0 && (
                <div className="cd-activity-empty">
                    Unable to load payment schedules.
                </div>
            )}
            {!loading && !error && edges.length === 0 && (
                <div className="cd-activity-empty">No scheduled payments.</div>
            )}
            {edges.map(({ node: s }) => (
                <div key={s.id} className="cd-schedule">
                    <div className="cd-schedule-head">
                        <span className={pillClass(s.status)}>
                            <span className="dot" />
                            {s.status}
                        </span>
                        <span className="amount">${s.amountToCharge}</span>
                    </div>
                    <div className="cd-schedule-meta">{fmtFullDateTime(s.scheduleDatetime)}</div>
                    {s.notes && <div className="cd-schedule-notes">{s.notes}</div>}
                </div>
            ))}
            {(pageInfo.hasNextPage || stack.length > 0) && (
                <div className="cd-section-pager">
                    <button
                        type="button"
                        className="cd-btn outline sm"
                        onClick={prev}
                        disabled={stack.length === 0 || loading}
                    >
                        Prev
                    </button>
                    <button
                        type="button"
                        className="cd-btn outline sm"
                        onClick={next}
                        disabled={!pageInfo.hasNextPage || loading}
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    )
}
